<template>
  <div style="padding: 20px 8%">
    <div class="text-blue font-weight-bold">请填写复杂策略的相关信息</div>
    <div class="margin-top-30">
      <div class="display-flex">
        <div style="flex-basis: 100px;" class="text-right text-grey">触发条件：</div>
        <el-radio-group v-model="condition" style="margin-bottom: -9px">
          <el-radio :label="item.id" @change="clear"
                    v-for="item in checkGroup" :key="item.id">
            {{ item.label }}
          </el-radio>
        </el-radio-group>
      </div>
      <div class="display-flex margin-top-20">
        <div style="flex-basis: 100px;" class="text-right text-grey">策略名称：</div>
        <div style="flex-basis: calc(100% - 100px);">
          <el-input size="mini" style="width: 60%;" placeholder="请输入策略名称" v-model="name"></el-input>
        </div>
      </div>
      <div class="display-flex margin-top-20">
        <div style="flex-basis: 100px;" class="text-right text-grey">工作模式：</div>
        <div style="flex-basis: calc(100% - 100px);">
          <el-select
            placeholder="请选择工作模式"
            size="mini"
            style="width: 60%;"
            v-model="mode">
            <el-option value="0" label="待机"></el-option>
            <el-option value="1" label="工作"></el-option>
          </el-select>
        </div>
      </div>
      <div class="display-flex margin-top-20" v-if="condition === '1'">
        <div style="flex-basis: 100px;" class="text-right text-grey">设备：</div>
        <div style="flex-basis: calc(100% - 100px);">
          <el-cascader
            :props="defaultProps"
            :options="spaceTree"
            change-on-select="true"
            clearable
            placeholder="请选择空间"
            size="mini"
            style="width: 60%"
            v-model="spaceId">
          </el-cascader>
        </div>
      </div>
      <div class="display-flex margin-top-10" v-if="condition === '1'">
        <div style="flex-basis: 100px;" class="text-right text-grey"></div>
        <div style="flex-basis: calc(100% - 100px);">
          <el-select
            placeholder="请选择设备"
            size="mini"
            style="width: 60%;"
            v-model="deviceId">
            <el-option
              :key="item.id"
              :label="item.name"
              :value="item.id"
              v-for="item in deviceList">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="display-flex margin-top-10" v-if="condition === '1'">
        <div style="flex-basis: 100px;" class="text-right text-grey"></div>
        <div style="flex-basis: calc(100% - 100px);">
          <el-select
            placeholder="请选择测点"
            size="mini"
            style="width: 60%;"
            v-model="pointId">
            <el-option
              :key="item.id"
              :label="item.name"
              :value="item.id"
              v-for="item in pointList">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="display-flex margin-top-20" v-if="condition === '2'">
        <div style="flex-basis: 100px;" class="text-right text-grey">设备类型：</div>
        <div style="flex-basis: calc(100% - 100px);">
          <el-select
            placeholder="请选择设备类型"
            size="mini"
            style="width: 60%;"
            v-model="typeId">
            <el-option
              :key="item.id"
              :label="item.cnName"
              :value="item.id"
              v-for="item in typeList">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="display-flex margin-top-20">
        <div style="flex-basis: 100px;" class="text-right text-grey">流程：</div>
        <div style="flex-basis: calc(100% - 100px);">
          <el-select
            placeholder="请选择流程"
            size="mini"
            style="width: 60%;"
            v-model="processId">
            <el-option
              :key="item.pid"
              :label="item.name+' v'+item.version"
              :value="item.pid"
              v-for="item in processList">
            </el-option>
          </el-select>
          <span class="text-yellow margin-left-5">*流程将使用已发布的最新版本</span>
        </div>
      </div>
      <div class="display-flex margin-top-20">
        <div style="flex-basis: 100px;" class="text-right text-grey">状态：</div>
        <div style="flex-basis: calc(100% - 100px);">
          <el-radio label='true' style="margin-top: 7px;" v-model="isEnable">启用</el-radio>
          <el-radio label='false' style="margin-top: 7px;" v-model="isEnable">禁用</el-radio>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getDeviceList} from "@/network/device-info";
import {listByDeviceId} from "@/network/device-measuring-point";

export default {
  name: "ComplexStrategyForm",
  props: ['spaceTree', 'typeList', 'processList', 'editData'],
  data() {
    return {
      condition: "1",
      checkGroup: [
        {id: "1", label: "设备"},
        {id: "2", label: "设备类型"},
        // {id: "3", label: "固定时间"}
      ],
      defaultProps: {
        label: 'title',
        value: 'id',
        children: 'children'
      },
      id: '',
      activitiId: '',
      // 设备列表
      deviceList: [],
      // 测点列表
      pointList: [],
      // 选择的空间
      spaceId: [],
      spaceName: '',
      // 选择的设备
      deviceId: null,
      deviceName: '',
      // 选择的测点
      pointId: null,
      pointName: '',
      // 选择的设备类型
      typeId: null,
      typeName: '',
      // 选择的流程
      processId: null,
      processName: '',
      processKey: '',
      // 流程版本
      version: '',
      // 策略名称
      name: '',
      // 是否启用
      isEnable: 'true',
      mode: '0',
    }
  },
  watch: {
    condition() {
      // 触发条件修改，清空内容
      this.spaceId = []
      this.deviceList = []
      this.pointList = []
      this.deviceId = null
      this.pointId = null
      this.processKey = null

      this.spaceName = ''
      this.deviceName = ''
      this.pointName = ''
      console.log('清空');
    },
    spaceId() {
      // 设置名称
      if (this.spaceId.length <= 0) {
        return true;
      }
      // 设置名称
      if (!this.spaceTree) {
        return;
      }
      let item = this.spaceTree.filter(item => item.id === this.spaceId[this.spaceId.length - 1])[0]
      if (item) {
        this.spaceName = item.title
      }
      this.pointList = []
      // 获取空间下设备列表
      this.getDeviceList()
    },
    deviceId() {
      // 设置名称
      if (!this.deviceId) {
        return true;
      }
      let item = this.deviceList.filter(item => item.id === this.deviceId)[0]
      if (item) {
        this.deviceName = item.name
      }
      // 获取设备的测点列表
      this.getPointListByDeviceId();
    },
    pointId() {
      // 设置名称
      if (!this.pointId) {
        return true;
      }
      let item = this.pointList.filter(item => item.id === this.pointId)[0]
      if (item) {
        this.pointName = item.name
      }
    },
    processId() {
      if (!this.processId) {
        return;
      }
      // 设置名称
      let item = this.processList.filter(item => item.pid === this.processId)[0]
      if (item) {
        this.processName = item.name
        this.processKey = item.key
        // 设置流程版本
        this.version = item.version
      }
    },
    typeId() {
      if (!this.typeId) {
        return;
      }
      let item = this.typeList.filter(item => item.id === this.typeId)[0]
      this.typeName = item.cnName
    },
    editData() {
      this.setData(this.editData);
    }
  },
  mounted() {
    this.setData(this.editData);

  },
  methods: {
    // 切换触发条件
    clear() {
      this.typeId = null
      this.typeName = ''
    },
    // 获取空间下设备列表
    getDeviceList() {
      if (this.spaceId.length < 1) {
        this.deviceList = []
        return false;
      }
      getDeviceList(this.spaceId[this.spaceId.length - 1]).then(res => {
        if (res.code === 0) {
          this.deviceList = res.data
          if (!this.deviceId) {
            return;
          }
          let item = this.deviceList.filter(item => item.id === this.deviceId)[0]
          if (!item) {
            this.deviceId = '';
            this.deviceName = '';
            this.pointId = '';
            this.pointName = '';
          }
        }
      })
    },
    // 获取设备的测点列表
    getPointListByDeviceId() {
      if (!this.deviceId) {
        return;
      }
      listByDeviceId(this.deviceId).then(res => {
        if (res.code === 0) {
          this.pointList = res.data
          if (!this.pointId) {
            return;
          }
          let item = this.pointList.filter(item => item.id === this.pointId)[0]
          if (!item) {
            this.pointId = '';
            this.pointName = '';
          }
        }
      });
    },
    // 编辑值回显
    setData(data) {
      let hasData = true;
      if (!data) {
        hasData = false;
      }
      this.id = hasData ? data.id : '';
      this.isEnable = hasData ? data.isEnable + '' : 'true';
      let activiti = hasData ? data.deviceLinkageActiviti : {};
      this.activitiId = hasData ? activiti.id : '';
      this.name = hasData ? data.name : '';
      this.condition = '2';
      if (!activiti.deviceTypeId) {
        this.condition = '1';
      }
      this.spaceId = [];
      this.spaceId.push(hasData ? activiti.spaceId + '' : '');
      this.deviceId = hasData ? activiti.deviceId : '';
      this.pointId = hasData ? activiti.pointId : '';

      this.spaceName = hasData ? activiti.spaceName : '';
      this.deviceName = hasData ? activiti.deviceName : '';
      this.pointName = hasData ? activiti.pointName : '';

      this.processId = hasData ? activiti.procId : '';
      this.processName = hasData ? activiti.procName : '';
      this.processKey = hasData ? activiti.procKey : '';
      this.version = hasData ? activiti.procVersion : '';
      // deviceTypeId
      this.typeId = hasData ? activiti.deviceTypeId : '';
      this.typeName = hasData ? activiti.deviceTypeName : '';
      this.mode = hasData ? activiti.mode+'' : '0';
      console.log(this.typeId, this.typeName)
    }
  }
}
</script>

<style scoped>

</style>
